import { render, staticRenderFns } from "./Goal.vue?vue&type=template&id=344cf5cc&scoped=true&"
import script from "./Goal.vue?vue&type=script&lang=js&"
export * from "./Goal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344cf5cc",
  null
  
)

export default component.exports